import { render, staticRenderFns } from "./Smartfarm1.vue?vue&type=template&id=942889b8&"
import script from "./Smartfarm1.vue?vue&type=script&lang=js&"
export * from "./Smartfarm1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports